import { Navigation, Pagination, EffectFade, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { AnimatePresence, motion } from "framer-motion";
import { useRouter } from "next/router";
import { useContext } from "react";
import { isMobileContext } from "../../contexts/isMobileContext";
import OffersCard from "./OffersCard";
const Offers = ({ offersData }) => {
    const { locale } = useRouter()
    const { isMobile } = useContext(isMobileContext);
    return (
        <AnimatePresence>
            <div className="offers-section">
                <motion.div
                    initial={{ opacity: "0", }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: .25, duration: .75 }}
                    className="header light">
                    <h3 className="title">{offersData?.Header}</h3>
                    <motion.div
                        initial={{ opacity: "0", }}
                        whileInView={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: .3, duration: .75 }}
                        className={`arrows-container
                        ${offersData?.Our_Offers?.length <= 1 && "d-none"}
                        `}
                    >
                        <div className="swiper-button-prev swiper-button-prev-offers offers-arrow black-arrow-prev"
                        ></div>
                        <div className="swiper-button-next swiper-button-next-offers  offers-arrow black-arrow-next"
                        ></div>
                    </motion.div>
                </motion.div>
                <Swiper
                    key={offersData?.Our_Offers?.length}
                    style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                    modules={[
                        Navigation,
                        Pagination,
                        EffectFade,
                        Mousewheel,
                    ]}
                    
                    navigation={{
                        nextEl: ".swiper-button-next-offers",
                        prevEl: ".swiper-button-prev-offers",
                    }}
                    pagination={{
                        type: "progressbar",
                        el: ".swiper-offers-navigation",
                    }}
                    className="swiper-offers-section"
                    slidesPerView={1.1}
                    spaceBetween={25}
                    breakpoints={{
                        768: {
                            slidesPerView: 1.25,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 1.25,
                            spaceBetween: 50,
                        },
                    }}
                    // loop={true}
                >
                    {offersData?.Our_Offers?.map((data, index) => (
                        <SwiperSlide key={index}>
                            <OffersCard cardData={data} index={index} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div >
        </AnimatePresence>
    )
}

export default Offers